module.exports = __webpack_public_path__ + "static/media/service_icon_04.9aad5f28.webp";